import React, { useEffect, useRef, useState } from 'react';

const productsData = [
  {
    id: 1,
    category: "Tecnologia",
    title: "Soluções em Infraestrutura de TI",
    description: "Soluções completas em tecnologia para ambientes corporativos. Fornecimento e gestão de software, desktops e notebooks, infraestrutura de TI, servidores, nobreaks e sistemas de segurança eletrônica, com foco em estabilidade, desempenho e continuidade das operações críticas.",
    image: "/img/products/tecnologia.jpg"
  },
  {
    id: 2,
    category: "Indústria",
    title: "Insumos e Ferramentas Industriais",
    description: "Suprimentos MRO para ambientes industriais. Ferramentas manuais e elétricas, equipamentos de manutenção, itens de reposição e apoio operacional, garantindo disponibilidade, padronização e continuidade da produção.",
    image: "/img/products/mro.jpg"
  },
  {
    id: 3,
    category: "Corporativo",
    title: "Ambientes Corporativos",
    description: "Soluções para ambientes corporativos. Insumos de escritório, mobiliário ergonômico e estruturas de apoio para postos de trabalho, garantindo padronização, conforto operacional e produtividade em escala.",
    image: "/img/products/escritorio.jpg"
  },
  {
    id: 4,
    category: "Segurança",
    title: "Segurança do Trabalho",
    description: "Fornecimento de equipamentos de proteção individual para ambientes industriais e corporativos. Portfólio completo de EPIs certificados, atendendo às exigências normativas e garantindo segurança, padronização e conformidade operacional.",
    image: "/img/products/epi.jpg"
  },
  {
    id: 5,
    category: "Facilities",
    title: "Suprimentos de Limpeza e Higiene",
    description: "Suprimentos para limpeza e higiene em ambientes corporativos e industriais. Equipamentos, produtos e insumos profissionais que asseguram padronização, segurança sanitária e conformidade operacional.",
    image: "/img/products/higiene.jpg"
  },
  {
    id: 6,
    category: "Logística",
    title: "Embalagens Industriais",
    description: "Embalagens industriais para proteção e transporte de cargas. Fornecimento de soluções em papelão e madeira sob medida, certificadas, fumigadas e adequadas às exigências de exportação, garantindo integridade, conformidade e segurança na cadeia de suprimentos.",
    image: "/img/products/logistica.jpg"
  },
  {
    id: 7,
    category: "Saúde",
    title: "Produtos Médico-Hospitalares",
    description: "Fornecimento de produtos médico-hospitalares para ambientes clínicos e institucionais. Portfólio alinhado às exigências regulatórias, garantindo qualidade, rastreabilidade e segurança no abastecimento de instituições de saúde.",
    image: "/img/products/medico.jpg"
  },
  {
    id: 8,
    category: "Estratégia",
    title: "Sourcing Estratégico",
    description: "Serviço especializado de desenvolvimento e homologação de fornecedores para produtos de alta complexidade ou difícil obtenção. Atuação estratégica para identificar, qualificar e estruturar fontes de fornecimento, garantindo viabilidade, conformidade e continuidade operacional.",
    image: "/img/products/sourcing.jpg"
  }
];

const ProductRow = ({ product, index }) => {
  const rowRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={rowRef}
      className={`prod-item reveal-up ${isVisible ? 'is-visible' : ''}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="prod-image-wrapper">
        <img
          src={product.image}
          alt={product.title}
          loading="lazy"
        />
      </div>
      <div className="prod-content">
        <h3 className="overflow-hidden">
          <span className="block split-text-inner">{product.title}</span>
        </h3>
        <p>{product.description}</p>
      </div>
    </div>
  );
};

const ProductsSection = () => {
  return (
    <section id="produtos" className="bg-black py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-24 reveal-up is-visible">
          <span className="inline-block text-amber-500 text-sm font-semibold tracking-[0.3em] uppercase mb-4">
            Nosso Portfólio
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-8 tracking-tight">
            Soluções Corporativas
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-12 opacity-50"></div>
        </div>

        <div className="products-list">
          {productsData.map((product, index) => (
            <ProductRow
              key={product.id}
              product={product}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;

